module.exports = __webpack_public_path__ + "img/1399377895.82f1d3be.jpg";